export default __webpack_public_path__ + "static/media/microcosm.4d28e23a.svg";